import cn from 'classnames';
import React from 'react';
import Select, { Overrides } from 'components/Select';
import { ShareFormField } from 'components/ShareForm';
import ShareFormGroup from 'components/ShareForm/ShareFormGroup';
import { block } from '../utils';
import ReplyLevelOption from './ReplyLevelOption';
import {
  BlueskyReplyLevelSelectorOption,
  BlueskyReplyLevelSelectorProps,
} from './types';
import { getOptions, getReplyLevelOption } from './utils';

const selectComponentOverrides: Overrides<BlueskyReplyLevelSelectorOption> = {
  control: {
    props: p => ({
      ...p,
      className: cn(block('control'), p.className),
    }),
  },
  option: {
    component: ReplyLevelOption,
  },
};

const BlueskyReplyLevelSelector: React.FC<BlueskyReplyLevelSelectorProps> = ({
  value,
  className,
  selectClassName,
  onChange,
}) => {
  return (
    <ShareFormGroup className={className}>
      <ShareFormField label="Reply settings:">
        <Select
          value={getReplyLevelOption(value)}
          options={getOptions()}
          overrides={selectComponentOverrides}
          className={selectClassName}
          onChange={option => onChange?.(option.value)}
        />
      </ShareFormField>
    </ShareFormGroup>
  );
};

export default BlueskyReplyLevelSelector;
